module.exports = __webpack_public_path__ + "static/media/logo-conlicitaseg-texto.fd3a2629.svg";